import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter006() {
  return <KbChapterPage slug="chapter-006" />;
}

(Chapter006 as unknown as { path: string }).path = "/theory-album/006";
